<section class="section">
    <div class="section-header">
      <h2>{{ categoryTitle }}</h2>
      <p>{{ categorySubtitle }}</p>
    </div>
    
    <div class="category-grid">
      <div 
        *ngFor="let category of categories" 
        class="category-card"
        [class.selected]="isCategorySelected(category.id)"
        [class.multiple-selection]="isMultipleSelection"
        (click)="isMultipleSelection ? toggleCategorySelection(category.id) : selectCategory(category.id)">
        <h4>{{ category.title }}</h4>
        <div *ngIf="isMultipleSelection" class="checkbox-indicator">
          <i class="fas fa-check" *ngIf="isCategorySelected(category.id)"></i>
        </div>
      </div>
    </div>

    <!-- EAM Subcategory selector -->
    <div *ngIf="showEamSubcategory" class="subcategory-section">
      <h3>Select EAM Subcategory</h3>
      <p>You can select multiple subcategories</p>
      <div class="subcategory-grid">
        <div 
          *ngFor="let subCategory of subCategories" 
          class="subcategory-card"
          [class.selected]="isSubCategorySelected(subCategory)"
          (click)="toggleSubCategorySelection(subCategory)">
          <h5>{{ subCategory }}</h5>
          <div class="checkbox-indicator">
            <i class="fas fa-check" *ngIf="isSubCategorySelected(subCategory)"></i>
          </div>
        </div>
      </div>
      
      <!-- Proceed button for multiple subcategory selection -->
      <!-- [disabled]="!canProceedWithMultipleSubCategories" -->
      <div class="proceed-section">
        <button 
          class="btn btn-primary proceed-btn" 
          (click)="proceedWithMultipleSubCategories()">
          <i class="fas fa-arrow-right"></i>
          Proceed with {{ selectedSubCategories.length }} selected subcategories
        </button>
      </div>
    </div>

    <!-- Proceed button for multiple selection -->
    <div *ngIf="isMultipleSelection" class="proceed-section">
      <button 
        class="btn btn-primary proceed-btn" 
        [disabled]="!canProceedWithMultiple"
        (click)="proceedWithMultipleSelection()">
        <i class="fas fa-arrow-right"></i>
        Proceed with {{ selectedCategories.length }} selected categories
      </button>
    </div>
  </section>